'use strict';

const {gsap} = require("gsap");
const BREAKPOINTS = require("../../../experience/breakpoints.json");

/**
 * Function used to calculate the visible height of an element inside the viewport
 * @param {string} $elt - element
 * @returns {number} element's height in viewport
 */
function inViewport($elt) {
    const height = $elt.outerHeight(),
        windowHeight = $(window).height(),
        boundaries = $elt[0].getBoundingClientRect();

    return Math.max(0, boundaries.top > 0 ? Math.min(height, windowHeight - boundaries.top) : Math.min(boundaries.bottom, windowHeight));
}

const updateStepperHeight = () => {
    const isDesktop = window.innerWidth > BREAKPOINTS.tablet;
    if (isDesktop) {
        // Variables
        let headerHeight = inViewport($('header'));
        let footerHeight = inViewport($('footer'));
        const root = document.querySelector(':root');

        const footerHeightToRemove = getComputedStyle(root).getPropertyValue('--stepper-footer-height-to-remove');

        root.style.setProperty('--visible-header-height', headerHeight + 'px');
        root.style.setProperty('--visible-footer-height', 0 + 'px');

        // Scroll triggers to update stepper height
        setTimeout(() => {
            // Header scroll trigger
            gsap.timeline({
                scrollTrigger: {
                    markers: false,
                    trigger: 'header',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                    onUpdate: () => {
                        // Calculate the visible height of the header
                        headerHeight = inViewport($('header'));
                        root.style.setProperty('--visible-header-height', headerHeight + 'px');
                    },
                },
            });

            // Footer scroll trigger
            gsap.timeline({
                scrollTrigger: {
                    markers: false,
                    trigger: 'footer',
                    start: 'top bottom',
                    end: 'bottom bottom',
                    scrub: true,
                    onUpdate: () => {
                        // Calculate the visible height of the footer
                        footerHeight = Math.max(inViewport($('footer')) - footerHeightToRemove, 0);
                        root.style.setProperty('--visible-footer-height', footerHeight + 'px');
                    },
                },
            });
        }, window.STEP_ANIMAION_DURATION);
    }
};

const updateCurrentStepNumber = (currentStepNumber) => {
    const dotsContainer = $('.stepper_pagination__dots')[0];
    const $paginationNumbers = $('.stepper_pagination__numbers');

    // If we went back to the start
    if (currentStepNumber < 1) {
        gsap.to('.stepper__container', { autoAlpha: 0 });
    } else if (currentStepNumber === 1) {
        // If it's the first step, display the stepper
        gsap.to('.stepper__container', { autoAlpha: 1 });
    }

    // Set the active dot
    let paginationDot = $(dotsContainer).find('.stepper_pagination__dot');
    $(paginationDot).removeClass('active');
    $(paginationDot[currentStepNumber - 1]).addClass('active');

    // Update the pagination numbers aria label
    $paginationNumbers.attr('aria-label', `Step ${currentStepNumber} / ${$paginationNumbers.data('total-steps')}`);

    // Set the current page number
    document.querySelector(':root').style.setProperty('--stepper--number-position', currentStepNumber - 1 + '');
};

window.addEventListener('resize', updateStepperHeight);

module.exports = {
    updateStepperHeight,
    updateCurrentStepNumber
};
